module.exports = __webpack_public_path__ + "static/img/zw.6498c07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zw.png
// module id = LARo
// module chunks = 0